import React from 'react'
import { compose } from 'recompose'
import {
  bool,
  string,
  object,
} from 'prop-types'
import {
  IconButton,
  Divider,
} from 'material-ui'
import { withRouter } from 'react-router'
import muiThemeable from 'material-ui/styles/muiThemeable'
import NavigationTheme from 'cmsThemes/mui/Navigation'
import Navigation from './Navigation'

export const isMatchWithPathName = (menuName, location) => {
  const { pathname } = location
  return pathname === '/' ? (
    pathname.indexOf(menuName.toLowerCase()) !== -1
  ) : (
    pathname.indexOf(menuName.toLowerCase()) !== -1 && menuName !== '/'
  )
}

const Navigator = compose(
  withRouter,
  muiThemeable(),
)(
  ({
    collapse,
    toggleCollapse,
    navigationData,
    router,
    location,
    muiTheme: {
      appBar,
      CustomSideBar,
    },
  }) => (
    <div style={{
      marginTop: appBar.height,
      overflow: 'hidden',
    }}
    >
      <Navigation
        navigationData={navigationData}
        collapse={collapse}
        onClick={(pathname) => router.push(pathname)}
        checkActive={(value) => isMatchWithPathName(value, location)}
      />
      <div
        style={{
          ...NavigationTheme.footerStyle.all,
          backgroundColor: CustomSideBar.backgroundColor,
        }}
      >
        <Divider style={{ marginBottom: `${collapse ? '54px' : '0px'}` }} />
        {!collapse &&
        <img
          src="https://firebasestorage.googleapis.com/v0/b/test-e3729.appspot.com/o/Screen%20Shot%202560-08-02%20at%2011.40.11%20AM.png?alt=media&token=cbe83308-e49d-4ada-afdd-ce30b6f3d102"
          style={NavigationTheme.footerStyle.image}
        />
        }
        <div style={{
          textAlign: `${collapse ? 'center' : 'right'}`,
          ...NavigationTheme.footerStyle.divIcon,
        }}
        >
          <IconButton
            iconClassName={`fa fa-angle-${collapse ? 'right' : 'left'} fa-5x`}
            onTouchTap={toggleCollapse}
            iconStyle={NavigationTheme.footerStyle.iconStyle}
            style={{
              paddingRight: 0,
              marginLeft: `${collapse ? '-10px' : '0px'}`,
            }}
          />
        </div>
      </div>
    </div>
  )
)


Navigator.propTypes = {
  navigationData: object.isRequired,
  userRole: string.isRequired,
  collapse: bool,
  storeLogo: string,
  storeName: string,
}

Navigator.defaultProps = {
  collapse: false,
  storeLogo: 'https://s7d2.scene7.com/is/image/Fathead/lgo_ncaa_syracuse_orangemen?layer=comp&fit=constrain&hei=300&wid=300&fmt=png-alpha&qlt=95,0&op_sharpen=1&resMode=bicub&op_usm=0.0,0.0,0,0&iccEmbed=0',
  storeName: 'Cms',
}

export default Navigator



// WEBPACK FOOTER //
// ./src/components/Navigator/index.js